import './typingStyle.css'
import React from "react";

const Typing = () => {
    return <div className={"typing_container"}>
            <div className="typing__dot"/>
            <div className="typing__dot"/>
            <div className="typing__dot"/>
        <span>typing</span>
    </div>
}


export default Typing;